/**
 * Copyright (c) 2025-present, NDLA.
 *
 * This source code is licensed under the GPLv3 license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

// N.B! AUTOGENERATED FILE. DO NOT EDIT
// Source: RemixIcon
// License: Apache License 2.0
import type { JSX } from "react";
import { Icon, type Props } from "../Icon";
export const SpamLine = (props: Props): JSX.Element => (
  <Icon fill="currentColor" viewBox="0 0 24 24" {...props}>
    <path d="m15.94 2.5 5.56 5.57v7.87l-5.56 5.56H8.07L2.5 15.94V8.07L8.07 2.5zm-.83 2H8.89L4.5 8.9v6.2l4.4 4.4h6.2l4.4-4.4V8.9zM11 15h2v2h-2zm0-8h2v6h-2z" />
  </Icon>
);
